import api from './axiosService';

export const saleCloseoutApi = {
    getAll(params = {}) {
        return api.get('/sale-closeouts', { params });
    },

    getById(closeoutId) {
        return api.get(`/sale-closeouts/${closeoutId}`);
    },

    getByShop(shopId, params = {}) {
        return api.get(`/sale-closeouts/shop/${shopId}`, { params });
    },

    getTotalByShop(shopId, params = {}) {
        return api.get(`/sale-closeouts/shop/${shopId}/total`, { params });
    },

    getBySeller(shopSellerId, params = {}) {
        return api.get(`/sale-closeouts/seller/${shopSellerId}`, { params });
    },

    getTotalBySeller(shopSellerId, params = {}) {
        return api.get(`/sale-closeouts/seller/${shopSellerId}/total`, { params });
    },

    create(data) {
        return api.post('/sale-closeouts', data);
    },

    update(closeoutId, data) {
        return api.put(`/sale-closeouts/${closeoutId}`, data);
    },
};